import { createClient } from '@sanity/client';
import imageUrlBuilder from '@sanity/image-url';

export const client = createClient({
  projectId: 'kxxtoumf',
  dataset: 'production',
  apiVersion: '2025-05-12',
  useCdn: true,
  perspective: 'raw',
});

// Get a pre-configured url-builder from your sanity client
const builder = imageUrlBuilder(client);

// Then we like to make a simple function like this that gives the
// builder an image and returns the builder for you to specify additional
// parameters:
export const urlFor = (source) => source ? builder.image(source).url() : null;
